// import React, { useState } from "react";
// import "./VoyahDreamSpecMid.css";

// const VoyahDreamSpecMid = () => {
//   const [openIndex, setOpenIndex] = useState(null);

//   const toggle = (i) => {
//     setOpenIndex((prev) => (prev === i ? null : i));
//   };

//   // ============================================
//   // STATIC DATA — CHANGE ANYTIME YOU WANT
//   // ============================================
//   const sections = [
//     {
//       id: 1,
//       title: "Dimensions",
//       type: "table",
//       rows: [
//         { id: 1, label: "Length", value: "5,315 mm" },
//         { id: 2, label: "Width", value: "2,020 mm" },
//         { id: 3, label: "Height", value: "1,820 mm" },
//       ],
//     },
//     {
//       id: 2,
//       title: "Battery & Range",
//       type: "table",
//       rows: [
//         { id: 1, label: "Battery Capacity", value: "82 kWh" },
//         { id: 2, label: "Range (WLTP)", value: "620 km" },
//         { id: 3, label: "Charging 20–80%", value: "30 min" },
//       ],
//     },
//     {
//       id: 3,
//       title: "Available Colors",
//       type: "images",
//       images: [
//         { id: 1, label: "Pearl White", imageUrl: "/dream/colors/white.webp" },
//         { id: 2, label: "Midnight Black", imageUrl: "/dream/colors/black.webp" },
//         { id: 3, label: "Ocean Blue", imageUrl: "/dream/colors/blue.webp" },
//       ],
//     },
//   ];

//   return (
//     <section className="vf-spec dream-spec">
      
//       {/* TITLE */}
//       <h1 className="vf-title">VOYAH Dream Specifications</h1>

//       {/* NOTE */}
//       <p className="vf-small-note">S = Standard equipment at no extra cost</p>

//       {/* OPTIONAL TABS */}
//       <div className="vf-tabsSpecial">
//         <div className="vf-tabP">Comfort</div>
//         <div className="vf-tabP">Luxury</div>
//       </div>

//       {/* ACCORDION */}
//       <div className="accordion" id="dreamAccordion">
//         {sections.map((section, index) => (
//           <div className="accordion-item vf-item" key={section.id}>

//             {/* HEADER */}
//             <h2 className="accordion-header">
//               <button
//                 className={`accordion-button vf-header ${
//                   openIndex === index ? "" : "collapsed"
//                 }`}
//                 onClick={() => toggle(index)}
//               >
//                 {section.title}
//               </button>
//             </h2>

//             {/* BODY */}
//             <div
//               className={`accordion-collapse collapse ${
//                 openIndex === index ? "show" : ""
//               }`}
//             >
//               <div className="accordion-body p-0">

//                 {/* TABLE */}
//                 {section.type === "table" && (
//                   <table className="vf-table">
//                     <tbody>
//                       {section.rows.map((row) => (
//                         <tr key={row.id}>
//                           <td className="label">{row.label}</td>
//                           <td className="value">{row.value}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 )}

//                 {/* IMAGES */}
//                 {section.type === "images" && (
//                   <div className="vf-image-grid">
//                     {section.images.map((img) => (
//                       <div className="vf-image-card" key={img.id}>
//                         <div className="vf-image-wrapper">
//                           <img src={img.imageUrl} alt={img.label} />
//                         </div>
//                         <p className="vf-img-label">{img.label}</p>
//                       </div>
//                     ))}
//                   </div>
//                 )}
                
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* FOOTNOTE */}
//       <p className="vf-note">
//         All Dream specifications are indicative and subject to change without notice.
//       </p>

//     </section>
//   );
// };

// export default VoyahDreamSpecMid;


import React, { useEffect, useState, useContext } from "react";
import axios from "axios";

import "./VoyahDreamSpecMid.css";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahDreamSpecMid = () => {
  const { currentLang } = useContext(LanguageContext);

  const [sections, setSections] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  const toggle = (i) => {
    setOpenIndex((prev) => (prev === i ? null : i));
  };

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  // ======================================================
  // LOAD SPECIFICATIONS
  // ======================================================
  useEffect(() => {
    const loadSpecs = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/VoyahDreamSpec?lang=${currentLang}`
        );

        setSections(res.data);
      } catch (err) {
        console.error("Failed to load Dream Specs:", err);
      } finally {
        setLoading(false);
      }
    };

    loadSpecs();
  }, [currentLang]);

  if (loading) return <p className="vf-title">Loading...</p>;

  return (
    <section className="vf-spec dream-spec">
      
      {/* TITLE */}
      <h1 className="vf-title">VOYAH Dream Specifications</h1>

      {/* NOTE */}
      <p className="vf-small-note">S = Standard equipment at no extra cost</p>

      {/* OPTIONAL TABS */}
      <div className="vf-tabsSpecial">
        <div className="vf-tabP">Comfort</div>
        <div className="vf-tabP">Luxury</div>
      </div>

      {/* ACCORDION */}
      <div className="accordion" id="dreamAccordion">
        {sections.map((section, index) => (
          <div className="accordion-item vf-item" key={section.id}>

            {/* HEADER */}
            <h2 className="accordion-header">
              <button
                className={`accordion-button vf-header ${
                  openIndex === index ? "" : "collapsed"
                }`}
                onClick={() => toggle(index)}
              >
                {section.title}
              </button>
            </h2>

            {/* BODY */}
            <div
              className={`accordion-collapse collapse ${
                openIndex === index ? "show" : ""
              }`}
            >
              <div className="accordion-body p-0">

                {/* TABLE */}
                {section.type === "table" && (
                  <table className="vf-table">
                    <tbody>
                      {section.rows?.map((row) => (
                        <tr key={row.id}>
                          <td className="label">{row.label}</td>
                          <td className="value">{row.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {/* IMAGES */}
                {section.type === "images" && (
                  <div className="vf-image-grid">
                    {section.images?.map((img) => (
                      <div className="vf-image-card" key={img.id}>
                        <div className="vf-image-wrapper">
                          <img src={resolveUrl(img.imageUrl)} alt={img.label} />
                        </div>
                        <p className="vf-img-label">{img.label}</p>
                      </div>
                    ))}
                  </div>
                )}

              </div>
            </div>
          </div>
        ))}
      </div>

      {/* FOOTNOTE */}
      <p className="vf-note">
        All Dream specifications are indicative and subject to change without notice.
      </p>

    </section>
  );
};

export default VoyahDreamSpecMid;
